import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useWheelbarrow } from '../context/WheelbarrowContext';
import './PaymentSelection.css';

const PaymentSelection: React.FC = () => {
  const navigate = useNavigate();
  const { state } = useWheelbarrow();
  // Calculate total amount including service fee in pence
  const serviceFee = Math.round(state.totalPence * 0.1);
  const totalPence = state.totalPence + serviceFee;
  const totalGBP = totalPence / 100;

  const paymentMethods = [
    {
      id: 'card',
      name: 'Credit/Debit Card',
      description: 'Pay with GBP using your card',
      icon: '💳',
      route: '/payment/card'
    }
  ];

  return (
    <div className="payment-selection-page">
      <div className="breadcrumb">
        <button onClick={() => navigate('/')} className="breadcrumb-item">
          Categories
        </button>
        <span className="breadcrumb-separator">›</span>
        <button onClick={() => navigate('/checkout')} className="breadcrumb-item">
          Checkout
        </button>
        <span className="breadcrumb-separator">›</span>
        <span className="breadcrumb-item active">Select Payment Method</span>
      </div>

      <div className="payment-selection-content">
        <h1>Select Payment Method</h1>
        
        <div className="amount-summary">
          <div className="amount-row">
            <span>Total Amount:</span>
            <span className="amount">
              <span className="gbp">£{totalGBP.toFixed(2)}</span>
            </span>
          </div>
        </div>

        <div className="payment-methods">
          <div className="methods-grid">
            {paymentMethods.map((method) => (
              <button
                key={method.id}
                className="payment-method-card"
                onClick={() => navigate(method.route)}
              >
                <div className="method-icon">{method.icon}</div>
                <div className="method-details">
                  <h3>{method.name}</h3>
                  <p>{method.description}</p>
                </div>
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PaymentSelection; 